import {
  Identifiable,
  Planzone,
  Resource,
  resource as resourceMock,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedResource, Linker } from "../linkers/types";

type Response = {
  _embedded: {
    resources: LinkedResource<Identifiable<Resource>>[];
  };
};

function getPlanzoneResources(httpClient: HttpClient, linker: Linker) {
  return ({ uuid }: Identifiable<Planzone>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/resources?size=9999999&projection=details&embed_links=false`,
        method: HttpMethods.GET,
      })
      .then(({ _embedded }) =>
        _embedded.resources.map((resource) => ({
          ...resource,
          tags: resource.tags
            ? resource.tags.map((tag) => {
                // @ts-ignore
                return typeof tag === "string" ? { name: tag } : tag;
              })
            : [],
          deactivated: resource.deactivated,
          subordinates: (resource.subordinates ?? []).map((subordinate) => ({
            ...resourceMock,
            ...subordinate,
            avatarUrl: subordinate.avatarUrl ?? "",
            profession: subordinate.profession ?? "",
          })),
        })),
      )
      .then((promises) => Promise.all(promises))
      .catch((e) => Promise.reject({ ...e, message: e.detail || "" }));
}

export { getPlanzoneResources };
